<template>
    <div>
        <div class="bg_eef1fa wall web_main">
            <div class="main">
                <div class="text_pic_top_title mr_bottom_20 flex_space_between align_items_center">
                    <p>挂图</p>
                </div>
            </div>
            <div class="main no_bg flex_start flex_wrap">
                <div class="img_list" v-for="(item,index) in datalist" @click="goUrl(this,item.id,item.type)">
                    <div class="img_list_img">
                        <img :src="item.pic" />
                    </div>
                    <h2>{{item.title}}</h2>
                    <p class="flex_start flex_wrap">
                        <span v-for="(val,key) in item.flag">{{val}}</span>
                    </p>
                </div>
            </div>


            <div class="page" v-html="page_html">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "index",
        data(){
            return {
                page:1,
                datalist: [],
                hot_list: [],
                page_html :''
            }
        },
        created(){
            if(this.$route.query.page) {
                this.page = this.$route.query.page;
            }
            this.listChange('wall',this.page);
        },
        watch:{
        },
        mounted() {
        },
        methods:{
            listChange: function (type,page) {
                let _this = this;
                _this.page = page;
                this.$http({
                    url: 'index/listInfo',
                    method: 'post',
                    headers: {"Content-Type": "multipart/form-data"},
                    data:{page:page,type:type}
                }).then(res => {
                    if(res.data.code == 1) {
                        _this.datalist = res.data.data.list;
                        _this.page_html = res.data.data.page;
                    } else {
                        layer.msg(res.data.msg);
                    }
                });
            },
            goUrl: function (obj,id,type) {
                this.$router.push({
                    path: '/' + type + '/detail',
                    query: {
                        id: id
                    }
                })
            }
        },
    }
</script>

<style scoped>
    .wall{padding:45px 0 70px;}
    .text_pic_top_title{width:100%;padding-left:40px;position: relative;background:#fff;height: 70px;line-height: 70px;margin-bottom: 20px;position: relative;z-index: 2;}
    .text_pic_top_title::before{content:"";position: absolute;top:0;left:0;width: 8px;height: 70px;background:#627eb6;}
    .no_before::before{display: none;}
    .text_pic_top_title p{width: auto;font-size:40px;color:#333;display: block;}
    .text_pic_top_title a{width: auto;font-size:20px;color:#333;display: block;padding-right: 20px;}
    .img_list{width:282px;margin-right: 24px;display: block;background: #fff;padding:18.5px;margin-bottom: 20px;}
    .img_list:nth-child(4n){margin-right: 0;}
    .img_list a{width: 100%;display: block;}
    .img_list_img,.img_list_img img {width: 245px;height: 245px;object-fit: cover;display: block;transition: all ease .5s;overflow: hidden;border-radius: 5px;}
    .img_list:hover .img_list_img img{transform: scale(1.05);}
    .img_list h2{width:100%;padding:23px 15px 21px;font-size: 16px;line-height: 24px;height: 92px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;font-weight: normal;color:#333;}
    .img_list p{width: 100%;padding-bottom: 11.5px;}
    .img_list p span{width: auto;font-size:14px;line-height: 21px;padding:0 10px;color:#000;display: block;border:1px solid #000;border-radius: 16px;margin-right: 16px;margin-bottom: 5px}
    .page{max-width: 1200px;margin:15px auto;}


    @media screen and (max-width: 1920px) {

        .web_main{width:100%;padding:3.629vw 2% 5.645vw;}
        .img_list{width: calc(50% - 1vw);min-width: calc(50% - 1vw);margin-right: 2vw;margin-bottom:2vw;position: relative;padding:2vw;}
        .img_list:nth-child(2n){margin-right: 0;}
        .img_list_img{width: 100%;height: 40vw;max-height: 490px}
        .img_list_img img{width: 100%;height: 100%;object-fit: cover;display: block;}
        .img_list h2{width: 100%;margin:1.6vw 0;font-size: 2.58vw;line-height: 3vw;height: 6vw;padding:0;}
        .img_list p{padding-bottom: 0;}
        .img_list p span{border-radius: 5px;margin-right: 1.29vw;}

    }
    @media screen and (max-width: 750px) {
        .img_list h2, .wall_map_list h2 {
            font-size: 18px;
            line-height: 24px;
            height: 48px;
        }
    }
    @media screen and (max-width: 640px) {
        .text_pic_top_title p {
            font-size: 5.25vw;
        }

        .text_pic_top_title {
            margin-bottom: 3.2vw;
            height: 10.9375vw;
            line-height: 10.9375vw;
            padding-left: 6.25vw;
        }

        .text_pic_top_title::before {
            height: 10.9375vw;
        }
        .img_list p span{font-size:10px;line-height: 18px;padding:0 5px;}
        .img_list h2{font-size:16px;line-height: 18px;height: 36px;}
    }
    @media screen and (max-width: 440px) {
        /*.img_list{width:100%;margin-right: 0;}
        .img_list_img{height: 85vw;}*/
    }
</style>



// WEBPACK FOOTER //
// src/pages/wall/index.vue